import React from 'react';
import { useParams } from 'react-router';
import { FlowsQuestion } from '../../types/FlowsTypes';
import { FlowRouteParams } from '../../types/RouteParams';
import { getFlowInputComponents } from './InputList';

interface Props {
  question: FlowsQuestion;
}

/**
 * The Input Selector chooses the right input component for the provided question
 * @param question The question to be used for the input selector
 */
const InputSelector: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const { flowId } = useParams<FlowRouteParams>();
  const inputs = getFlowInputComponents(flowId);
  const Input = inputs[question.rules.input_type] || inputs['input'];

  if (!inputs[question.rules.input_type]) {
    console.error('Invalid input type ' + question.rules.input_type);
    return <></>;
  }

  return <Input question={question} />;
};

export default React.memo(InputSelector);
